import { render, staticRenderFns } from "./moor-button.vue?vue&type=template&id=654f6b8e&scoped=true&"
import script from "./moor-button.vue?vue&type=script&lang=js&"
export * from "./moor-button.vue?vue&type=script&lang=js&"
import style0 from "./moor-button.vue?vue&type=style&index=0&id=654f6b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.5.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654f6b8e",
  null
  
)

component.options.__file = "moor-button.vue"
export default component.exports